import styled from 'styled-components';

import { BackgroundElement } from '@/core/interfaces/common';

import { colors } from '@/utils/constants';

export const TypeButtonsWrapper = styled.div<BackgroundElement>`
  display: inline-block;
  margin: 40px auto 12px;
  border: 1px solid ${({ backgroundcolor }) => backgroundcolor};
  border-radius: 8px;
  padding: 4px;
  background-color: ${colors.white};
`;

interface RadioLabel extends BackgroundElement {
  checked: boolean;
}

export const TypeRadio = styled.label<RadioLabel>`
  display: inline-block;
  border-radius: 4px;
  padding: 13px 16px;
  background-color: ${props => (props.checked ? props.backgroundcolor : colors.white)};
  color: ${props => (props.checked ? props.textcolor : colors.black)};
  font-size: 16px;
  cursor: pointer;

  input {
    position: fixed;
    opacity: 0;
    width: 0;
  }
`;
